import { render } from "./Error404Component.vue?vue&type=template&id=7179a338"
import script from "./Error404Component.vue?vue&type=script&lang=js"
export * from "./Error404Component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__